;(function (GC) {
  var cookieName = '_gc_accepted_cookies'

  var logAcceptance = function () {
    var endpoint = '/events/accepted_cookies'
    var config = {
      url: endpoint,
      data: {
        event: 'accepted_cookies',
      },
    }
    // Ideally we would not use jQuery here, but using it for now to
    // give us the optimal browser support. Recommend swapping it out
    // for axios or a fetch polyfill at some point in the future...
    $.ajax(config)
  }

  var setExpire = function (time) {
    var date = new Date(time)
    var newDate = new Date(date.setYear(date.getFullYear() + 1))
    return 'expires=' + newDate.toUTCString()
  }

  var getDomain = function () {
    var domain = window.location.hostname
    return 'domain=' + domain
  }

  var setCookie = function () {
    var cookie = cookieName + '=true'
    var expire = setExpire(Date.now())
    var domain = getDomain()
    var path = 'path=/'
    document.cookie = [cookie, expire, domain, path].join('; ')
  }

  var checkCookie = function () {
    if (
      document.cookie.split(';').filter(function (item) {
        return item.indexOf(cookieName + '=true') >= 0
      }).length
    ) {
      return true
    }
  }

  var manageDrift = function () {
    var driftChat = document.querySelector('#drift-frame-controller')
    if (driftChat) {
      driftChat.classList.toggle('cookie--active')
    }
  }

  var addCookieNotification = function () {
    manageDrift()
    var target = document.querySelector('body')
    var cookiePolicy = document.createElement('div')
    var alertWrapper = document.createElement('div')
    var button = document.createElement('button')
    var cookieBottom = document.createElement('div')
    var createLinkButton = function (url, modifierClass, label) {
      var link = document.createElement('a')
      link.innerText = label
      link.href = url
      link.className = 'cookie-sticky__link ' + modifierClass
      return link
    }

    var msg = document.createElement('p')
    var msgText = 'By using our website, you agree to our use of cookies.'

    var buttonText = 'OK'

    cookiePolicy.id = 'cookie--policy-container'
    cookiePolicy.className = 'fixed--alert foundry--card alert fade in'
    cookiePolicy.setAttribute('role', 'alert')

    alertWrapper.className = 'cookie--policy'

    button.className =
      'foundry--button button--active-alt cookie--policy__button'
    button.type = 'button'
    button.innerText = buttonText
    button.setAttribute('data-dismiss', 'alert')

    msg.innerText = msgText
    msg.className = 'cookie--row'

    cookieBottom.className = 'cookie--row'

    button.addEventListener('click', function () {
      manageDrift()
      logAcceptance()
      setCookie(Date.now())
    })

    var privacyLink = createLinkButton(
      '/content/about-us/policy/privacy-policy/',
      'cookie-sticky__link--more',
      'More Info'
    )
    var caPrivacyLink = createLinkButton(
      '/content/about-us/policy/privacy-notice-for-californians/',
      'cookie-sticky__link--ca',
      'CA Policy'
    )
    var bottomRowElements = [privacyLink, caPrivacyLink, button]
    bottomRowElements.forEach(function (el) {
      cookieBottom.appendChild(el)
    })
    var elements = [msg, cookieBottom]
    elements.forEach(function (el) {
      alertWrapper.appendChild(el)
    })

    cookiePolicy.appendChild(alertWrapper)
    target.appendChild(cookiePolicy)
  }

  var showCookieMsg = function () {
    var cookieExists = checkCookie()
    var loggedIn = window.logged_in === true

    // This is to try to keep the cookie in place for logged in users.
    if (loggedIn && !cookieExists) {
      setCookie()
    }

    if (cookieExists || loggedIn) {
      return false
    }

    return true
  }

  var cookies = {
    addCookieNotification: addCookieNotification,
    checkCookie: checkCookie,
    setCookie: setCookie,
  }

  GC.cookies = cookies

  $(window).on('load', function () {
    if (showCookieMsg()) {
      addCookieNotification()
    }
  })
})(window.GC || {})
